(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tp-accordion"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.tpAccordion) return;
    window.tpAccordion = true;
    const timing = { duration: 450, easing: 'ease' };
    document.addEventListener('click', (event) => {
      const summary = event.target.closest('.tp-acc > summary');
      if (!summary || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const row = summary.parentElement;
      const panel = row.querySelector(':scope > .tp-acc__panel');
      event.preventDefault();
      const opening = !row.open || row.classList.contains('is-closing');
      const from = row.open ? panel.offsetHeight : 0;
      panel.getAnimations().forEach((a) => a.cancel());
      row.classList.remove('is-closing');
      row.open = true;
      if (opening) {
        panel.animate([{ height: `${from}px`, opacity: from ? 1 : 0 }, { height: `${panel.scrollHeight}px`, opacity: 1 }], timing);
      } else {
        row.classList.add('is-closing');
        panel.animate([{ height: `${from}px`, opacity: 1 }, { height: '0px', opacity: 0 }], timing).onfinish = () => {
          row.classList.remove('is-closing');
          row.open = false;
        };
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tp-marquee"] && !Shopify.designMode) return;
  try {
    (() => {
    // One loop moves the rail by one lane, so duration = lane width / px per second. A ResizeObserver catches
    // viewport resizes, late fonts and images alike.
    const ro = new ResizeObserver((entries) => {
      for (const { target } of entries) {
        const m = target.closest('.tp-marquee[data-pps]');
        const pps = m && parseFloat(m.dataset.pps);
        if (pps > 0 && target.offsetWidth) m.style.setProperty('--tp-marquee-speed', (target.offsetWidth / pps).toFixed(2) + 's');
      }
    });
    const scan = () => document.querySelectorAll('.tp-marquee[data-pps] > .tp-marquee__rail > .tp-marquee__lane:first-child').forEach((l) => ro.observe(l));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
    document.addEventListener('shopify:section:load', scan);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tp-pdp-lower"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.tpPdpLower) return;
    window.tpPdpLower = true;
    const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

    const selectTab = (tab, focus) => {
      const list = tab.closest('[role="tablist"]');
      list.querySelectorAll('[role="tab"]').forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        document.getElementById(t.getAttribute('aria-controls')).hidden = !on;
      });
      if (focus) tab.focus();
    };

    document.addEventListener('click', (event) => {
      const tab = event.target.closest('.tp-pit__tab');
      if (tab) return selectTab(tab);

      const toggle = event.target.closest('.tp-hb__toggle');
      if (!toggle) return;
      const extra = document.getElementById(toggle.getAttribute('aria-controls'));
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      const label = toggle.textContent.trim();
      toggle.textContent = toggle.dataset.less;
      toggle.dataset.less = label;
      toggle.setAttribute('aria-expanded', open);
      extra.getAnimations().forEach((a) => a.cancel());
      if (open) extra.hidden = false;
      if (reduce()) return (extra.hidden = !open);
      const h = extra.scrollHeight;
      const frames = [{ height: '0px', opacity: 0 }, { height: `${h}px`, opacity: 1 }];
      extra.animate(open ? frames : frames.reverse(), { duration: 450, easing: 'ease' }).onfinish = () => {
        extra.hidden = !open;
      };
    });

    document.addEventListener('keydown', (event) => {
      const tab = event.target.closest('.tp-pit__tab');
      if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const tabs = [...tab.parentElement.querySelectorAll('[role="tab"]')];
      const i = tabs.indexOf(tab);
      const next = { ArrowLeft: i - 1, ArrowRight: i + 1, Home: 0, End: tabs.length - 1 }[event.key];
      event.preventDefault();
      selectTab(tabs[(next + tabs.length) % tabs.length], true);
    });

    // Upsell cards add in place. Without JS, or if the request fails, the form posts natively to /cart/add.
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('form[data-tp-form="upsell"]');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      button.disabled = true;
      try {
        const res = await fetch(`${form.action}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (!res.ok) throw new Error(res.status);
        const item = await res.json();
        form.dispatchEvent(new CustomEvent('tp:cart-added', { bubbles: true, detail: { item } }));
        const label = button.textContent;
        button.textContent = button.dataset.added;
        setTimeout(() => {
          button.textContent = label;
          button.disabled = false;
        }, 1100);
      } catch {
        form.submit();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tp-sticky-atc"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (bar) => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = '1';
      const root = document.getElementById(`shopify-section-${bar.dataset.section}`) || document;
      const variants = JSON.parse(bar.querySelector('[data-tp-sticky-variants]').textContent);
      const form = bar.querySelector('form');
      const select = form.querySelector('select[name="id"]');
      const button = form.querySelector('[type="submit"]');
      const mainForm = root.querySelector('form[action*="/cart/add"]:not([data-tp-form])');
      const mainAtc = root.querySelector('[data-tp-main-atc], [data-tp-atc]') || mainForm?.querySelector('[type="submit"]');

      // Show while the main ATC is off screen, once it has scrolled away above or `[data-tp-sticky-start]`
      // (the gallery) has: on a phone the ATC sits far below the gallery, so waiting to pass it is too late.
      const target = mainAtc || mainForm;
      const start = root.querySelector('[data-tp-sticky-start]');
      if (target) {
        const state = new Map();
        const update = () => {
          const atc = state.get(target);
          const gallery = start && state.get(start);
          const above = (e) => e && !e.isIntersecting && e.boundingClientRect.top < 0;
          const show = !!atc && !atc.isIntersecting && (above(atc) || above(gallery));
          bar.classList.toggle('is-past-atc', show);
          bar.inert = !show;
          // display:none bars (e.g. picker's desktop rule) measure 0, so the teaser stays put there.
          document.documentElement.style.setProperty('--tp-sticky-h', `${show ? bar.offsetHeight : 0}px`);
        };
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => state.set(e.target, e));
          update();
        });
        io.observe(target);
        if (start) io.observe(start);
      } else {
        bar.classList.add('is-past-atc');
        bar.inert = false;
      }

      const render = (id) => {
        const v = variants.find((x) => String(x.id) === String(id));
        if (!v) return null;
        if (select) select.value = v.id;
        else form.elements.id.value = v.id;
        button.disabled = !v.available;
        button.querySelector('[data-label]').textContent = v.available ? 'Add to cart' : 'Sold out';
        button.querySelector('[data-price-wrap]').hidden = !v.available;
        button.querySelector('[data-price]').innerHTML = v.price;
        const compare = button.querySelector('[data-compare]');
        compare.innerHTML = v.compare || '';
        compare.hidden = !v.compare;
        [bar, ...root.querySelectorAll('.tp-sr')].forEach((el) => {
          const stock = el.querySelector('[data-stock]');
          if (!stock) return;
          stock.hidden = !v.stock;
          stock.querySelectorAll('i').forEach((bit, i) => bit.classList.toggle('is-low', i < v.stock));
        });
        return v;
      };

      // Main -> bar.
      const fromMain = () => mainForm?.elements.id && render(mainForm.elements.id.value);
      root.addEventListener('change', (e) => {
        if (!bar.contains(e.target)) setTimeout(fromMain);
      });
      const onEvent = (e) => {
        const d = e.detail || {};
        if (d.sectionId && d.sectionId !== bar.dataset.section) return;
        const id = d.variant ? d.variant.id : d.id;
        if (id) render(id);
      };
      root.addEventListener('tp:variant-change', onEvent);
      if (root !== document) document.addEventListener('tp:variant-change', onEvent);
      if (mainForm?.elements.id instanceof HTMLInputElement) {
        new MutationObserver(fromMain).observe(mainForm.elements.id, { attributes: true, attributeFilter: ['value'] });
      }
      fromMain();

      // Bar -> main.
      select?.addEventListener('change', () => {
        const v = render(select.value);
        if (!v || !mainForm) return;
        v.options.forEach((value) => {
          root.querySelectorAll('input[type="radio"]').forEach((r) => {
            if (!bar.contains(r) && r.value === value && !r.checked) r.click();
          });
          root.querySelectorAll('select:not([name="id"])').forEach((s) => {
            if (bar.contains(s) || s.value === value || ![...s.options].some((o) => o.value === value)) return;
            s.value = value;
            s.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
        const id = mainForm.elements.id;
        if (id && id.value !== String(v.id)) {
          id.value = v.id;
          id.dispatchEvent(new Event('change', { bubbles: true }));
        }
        (root === document ? document : root).dispatchEvent(new CustomEvent('tp:variant-select', { bubbles: true, detail: { id: v.id } }));
      });

      // The bar adds through the main form so bundle apps and the cart drawer behave the same.
      form.addEventListener('submit', (e) => {
        if (!mainAtc || mainAtc.disabled) return;
        e.preventDefault();
        mainAtc.click();
      });

      const sale = bar.querySelector('.tp-sticky__sale');
      if (sale) {
        const end = Number(sale.dataset.end) * 1000;
        const pad = (n) => String(n).padStart(2, '0');
        const out = ['h', 'm', 's'].map((k) => sale.querySelector(`[data-${k}]`));
        const tick = () => {
          const left = Math.floor((end - Date.now()) / 1000);
          if (left <= 0) {
            clearInterval(timer);
            sale.remove();
            return;
          }
          [Math.floor(left / 3600), Math.floor((left % 3600) / 60), left % 60].forEach((n, i) => {
            out[i].textContent = pad(n);
          });
        };
        const timer = setInterval(tick, 1000);
        tick();
      }
    };

    const boot = () => document.querySelectorAll('[data-tp-sticky]').forEach(init);
    boot();
    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
